export default __webpack_public_path__ + "static/media/venus-bg-effect.f5c16d8e.svg";